"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
var _Site = require("../Site.config");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(expandOnHover, isSelected, isOpen, isMoreMenuItem, withTopSeparator) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccSideBarStyle = (0, _react.useMemo)(function () {
    var deviceProps = function deviceProps() {
      if (isMobileView && !isMoreMenuItem) {
        return {
          top: 'auto',
          width: '100vw',
          height: pxToRem(_Site.sidebarHeight),
          zIndex: 5,
          boxShadow: "0 0 ".concat(pxToRem(7), " ").concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.shadow)
        };
      }
      return {
        top: 0,
        transition: 'width 0.5s ease',
        width: pxToRem(expandOnHover ? _Site.sidebarShrinkWidth : _Site.sidebarWidth),
        zIndex: 1,
        '&:hover': {
          width: pxToRem(_Site.sidebarWidth)
        }
      };
    };
    var menuDeviceProps = function menuDeviceProps() {
      if (isMobileView && !isMoreMenuItem) {
        return {
          width: '100%',
          height: '100%',
          margin: 0,
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light
        };
      }
      return {
        margin: pxToRem(10)
      };
    };
    var menuItemDeviceProps = function menuItemDeviceProps() {
      if (isMobileView && !isMoreMenuItem) {
        return {
          flex: '1 1',
          fontSize: pxToRem(14)
        };
      }
      return {
        marginTop: pxToRem(4)
      };
    };
    var menuItemAnchorContentDeviceProps = function menuItemAnchorContentDeviceProps() {
      if (isMobileView && !isMoreMenuItem) {
        return {
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center'
        };
      }
      return {
        flexDirection: 'row',
        justifyContent: 'flex-start'
      };
    };
    var ccSideBar = (0, _css.css)(_objectSpread({
      fontFamily: fontFamily,
      position: 'absolute',
      bottom: 0
    }, deviceProps()));
    var ccSideBarMenu = (0, _css.css)(_objectSpread({
      listStyle: 'none',
      padding: 0,
      fontWeight: 'bold'
    }, menuDeviceProps()));
    var ccSideBarMenuItem = (0, _css.css)(_objectSpread(_objectSpread({}, menuItemDeviceProps()), {}, {
      borderTop: withTopSeparator ? "1px solid #DAD9FC" : '',
      paddingTop: withTopSeparator ? pxToRem(4) : '0'
    }));
    var ccSideBarMenuItemAnchor = function ccSideBarMenuItemAnchor() {
      return {
        width: '100%',
        boxSizing: 'border-box',
        paddingInline: 0,
        height: isMobileView ? isMoreMenuItem ? pxToRem(30) : '100%' : pxToRem(36),
        color: isSelected ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : 'inherit',
        background: isSelected ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main : ''
      };
    };
    var ccSideBarMenuItemAnchorContent = (0, _css.css)(_objectSpread({
      display: 'inline-flex',
      alignItems: 'center',
      width: '100%',
      overflow: 'hidden',
      height: '100%'
    }, menuItemAnchorContentDeviceProps()));
    var menuItemLabelDeviceProps = function menuItemLabelDeviceProps() {
      if (isMobileView) {
        if (isMoreMenuItem) {
          return {
            // padding: `0 ${pxToRem(4)}`,
            marginRight: pxToRem(10),
            fontSize: pxToRem(16)
          };
        }
        return {
          padding: "".concat(pxToRem(4), " 0"),
          fontSize: pxToRem(12),
          lineHeight: 1
        };
      }
      return {
        // padding: pxToRem(4),
        marginInlineStart: pxToRem(10),
        fontSize: 'inherit'
      };
    };
    var ccSideBarMenuItemIcon = (0, _css.css)({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    });
    var BarMenuItemLabelExpandOnHover = function BarMenuItemLabelExpandOnHover() {
      if (expandOnHover) {
        return {
          transition: 'width 0.5s ease',
          overflow: 'hidden',
          textWrap: 'nowrap',
          width: '100%'
        };
      }
      return {};
    };
    var ccSideBarMenuItemLabel = (0, _css.css)(_objectSpread(_objectSpread({
      // lineHeight: 1,
      display: 'flex',
      alignItems: 'center'
    }, BarMenuItemLabelExpandOnHover()), menuItemLabelDeviceProps()));
    var ccSideBarMenuItemNewItem = (0, _css.css)({
      background: 'linear-gradient(180deg, #5750FA 0%, #0A00FF 100%)',
      borderRadius: pxToRem(20),
      border: 'none',
      padding: "".concat(pxToRem(2.5), " ").concat(pxToRem(9), " ").concat(pxToRem(2)),
      marginInlineStart: 'auto',
      marginLeft: pxToRem(12),
      lineHeight: pxToRem(18),
      textAlign: 'center',
      fontSize: isMobileView ? pxToRem(10) : pxToRem(12),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
      fontWeight: 'normal',
      letterSpacing: 0.75,
      width: 'auto',
      transition: 'width 0.5s ease'
    });
    var ccSideBarMenuItemArrow = (0, _css.css)({
      display: 'flex',
      alignItems: 'center',
      marginInlineStart: 'auto',
      marginLeft: pxToRem(12),
      transform: isOpen ? 'scaleY(-1)' : 'scaleY(1)',
      transition: 'transform .2s ease-in-out'
    });
    var ccSideBarMenuItemInnerList = (0, _css.css)({
      fontWeight: 'normal',
      paddingInlineStart: pxToRem(24),
      transition: 'max-height .3s ease-in-out',
      listStyleType: 'none',
      maxHeight: isOpen ? pxToRem(480) : 0,
      overflow: 'hidden'
    });
    var ccSideBarMenuItemMoreBtn = (0, _css.css)({
      fontSize: pxToRem(12),
      fontWeight: 'bold',
      display: 'flex',
      flexDirection: 'column'
    });
    var ccSideBarMenuItemMoreMenu = (0, _css.css)({
      listStyle: 'none',
      padding: 0,
      fontWeight: 'bold'
    });
    return {
      ccSideBar: ccSideBar,
      ccSideBarMenu: ccSideBarMenu,
      ccSideBarMenuItem: ccSideBarMenuItem,
      ccSideBarMenuItemIcon: ccSideBarMenuItemIcon,
      ccSideBarMenuItemLabel: ccSideBarMenuItemLabel,
      ccSideBarMenuItemNewItem: ccSideBarMenuItemNewItem,
      ccSideBarMenuItemArrow: ccSideBarMenuItemArrow,
      ccSideBarMenuItemAnchor: ccSideBarMenuItemAnchor,
      ccSideBarMenuItemAnchorContent: ccSideBarMenuItemAnchorContent,
      ccSideBarMenuItemInnerList: ccSideBarMenuItemInnerList,
      ccSideBarMenuItemMoreBtn: ccSideBarMenuItemMoreBtn,
      ccSideBarMenuItemMoreMenu: ccSideBarMenuItemMoreMenu
    };
  }, [fontFamily, pxToRem, isOpen, isMobileView, isMoreMenuItem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.shadow, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main, isSelected, withTopSeparator, expandOnHover]);
  return {
    'cc-SideBar': ccSideBarStyle.ccSideBar,
    'cc-SideBar__menu': ccSideBarStyle.ccSideBarMenu,
    'cc-SideBar__menu__item': ccSideBarStyle.ccSideBarMenuItem,
    'cc-SideBar__menu__item__anchor': ccSideBarStyle.ccSideBarMenuItemAnchor,
    'cc-SideBar__menu__item__anchor-content': ccSideBarStyle.ccSideBarMenuItemAnchorContent,
    'cc-SideBar__menu__item__icon': ccSideBarStyle.ccSideBarMenuItemIcon,
    'cc-SideBar__menu__item__label': ccSideBarStyle.ccSideBarMenuItemLabel,
    'cc-SideBar__menu__item__new-item': ccSideBarStyle.ccSideBarMenuItemNewItem,
    'cc-SideBar__menu__item__arrow': ccSideBarStyle.ccSideBarMenuItemArrow,
    'cc-SideBar__menu__item__inner-list': ccSideBarStyle.ccSideBarMenuItemInnerList,
    'cc-SideBar__menu__item__more-btn': ccSideBarStyle.ccSideBarMenuItemMoreBtn,
    'cc-SideBar__menu__item__more-menu': ccSideBarStyle.ccSideBarMenuItemMoreMenu
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;